<template>
  <div v-if="deployment" class="gp-content">
    <content-tab-bar :tabs="tabs"></content-tab-bar>
    <transition name="fade" mode="out-in">
      <router-view :deployment="deployment"></router-view>
    </transition>
  </div>
</template>

<script>
import ContentTabBar from '@/components/ContentTabBar.vue';

export default {
  name: 'Deployment',
  components: { ContentTabBar },
  computed: {
    tabs() {
      return [
        {
          label: 'Deployment Info',
          link: {
            name: 'deployments.index.detail',
            params: { id: this.deployment.id },
          },
          icon: 'info',
        },
        {
          label: 'Delete',
          link: {
            name: 'deployments.index.detail.delete',
            params: { id: this.deployment.id },
          },
          icon: 'delete',
        },
      ];
    },
  },
  async mounted() {
    this.deployment = await this.$store.dispatch('primary/getDeployment', {
      id: this.$route.params.id,
    });
  },
  data() {
    return {
      deployment: null,
    };
  },
};
</script>
